import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
    updatePrice = (event) => {
      if (event.detail.data.newProduct) {
        this.dataset.productId = event.detail.data.newProduct.id;
      } else if (
        event.target instanceof HTMLElement &&
        event.target.dataset.productId !== this.dataset.productId
      ) {
        return;
      }
    
      const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
      const currentPrice = this.querySelector('[ref="priceContainer"]');
    
      if (!newPrice || !currentPrice) return;
    
      if (currentPrice.innerHTML !== newPrice.innerHTML) {
        currentPrice.replaceWith(newPrice);
      }
    
      // ✅ Now update Recharge price after DOM settles
      this.#updateRechargePrice(newPrice?.textContent?.trim());
    };

    #updateRechargePrice = (newText) => {
      if (!newText) return;
    
      const parsePrice = (text) => {
        const match = text.replace(/[^\d.]/g, '');
        return parseFloat(match || 0);
      };
    
      let tries = 0;
      const interval = setInterval(() => {
        const rcPrice = document.querySelector('.rc-option__price');
        const subsavePrice = document.querySelector('.rc_widget__price--subsave');
        const subsaveDiscountText = document.querySelector('.rc-option__discount')?.textContent.trim();
    
        if (rcPrice) {
          rcPrice.textContent = newText;
          console.log('[RC] Updated one-time price:', newText);
        }
    
        if (rcPrice && subsavePrice) {
          const basePrice = parsePrice(newText);
    
          let discounted = basePrice;
    
          if (subsaveDiscountText && subsaveDiscountText.includes('%')) {
            const percent = parseFloat(subsaveDiscountText.replace('%', ''));
            if (!isNaN(percent)) {
              discounted = basePrice * ((100 - percent) / 100);
            }
          }
    
          const formatted = `$${discounted.toFixed(2)}`;
          subsavePrice.textContent = formatted;
    
          console.log('[RC] Updated subscribe & save price:', formatted);
          clearInterval(interval);
        }
    
        if (++tries > 10) {
          console.warn('[RC] Recharge elements not fully loaded after 10 tries.');
          clearInterval(interval);
        }
      }, 200);
    };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
